import React from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import { Card, CardContent } from '@material-ui/core';
import PropTypes from 'prop-types';
import styles from 'styles/pages/fiches-techniques.module.scss';
import getBrands from 'lib/getBrands';
import getBrandsModels from 'lib/getBrandsModels';
import Breadcrumb from 'components/breadcrumb';
import Link from 'components/link';
import { urlWriter } from 'tools/functions';

const WidgetNav = dynamic(() => import('../../components/widgetNav'), {
    ssr: false,
});

const WidgetLaunches = dynamic(() => import('../../components/widgetLaunches'), {
    ssr: false,
});

const WidgetPromo = dynamic(() => import('../../components/widgetPromotion'), {
    ssr: false,
});

const FicheTechniqueMain = ({ brands, brandsModels }) => {
    return (
        <div>
            <Head>
                <title>{`Fiches techniques voiture neuve au Maroc - ${new Date().getFullYear()}`}</title>
                <meta
                    name="description"
                    content="Fiches techniques de la marque et Soeezauto.ma "
                />
                <meta property="og:type" content="siteweb" />
                <meta
                    property="og:title"
                    content={`Fiches techniques voiture neuve au Maroc - ${new Date().getFullYear()}`}
                />
                <meta
                    property="og:image"
                    content={`${process.env.NEXT_PUBLIC_API_HOST}/images/og/fiches-techniques.png`}
                />
                <meta
                    property="og:url"
                    content={`${process.env.NEXT_PUBLIC_CLIENT_HOST}/fiches-techniques`}
                />
                <link
                    rel="canonical"
                    href={`${process.env.NEXT_PUBLIC_CLIENT_HOST}/fiches-techniques`}
                />
            </Head>

            <main className={styles.root}>
                <Breadcrumb
                    links={[
                        {
                            href: null,
                            text: 'Fiches techniques',
                        },
                    ]}
                />
                <div className="main-title">
                    <h1>Fiches techniques voitures neuve au Maroc</h1>
                </div>
                <div className={styles.mainContainer}>
                    <Card className={styles.cardRoot}>
                        <CardContent>
                            {brands.map((brand) => (
                                <Link
                                    key={brand.id}
                                    href={`/fiches-techniques/${urlWriter(brand.brand)}`}
                                >
                                    <Image
                                        src={`${process.env.NEXT_PUBLIC_API_HOST}/images/brands/${brand.image}`}
                                        alt={brand.brand}
                                        width="80"
                                        height="80"
                                        layout="fixed"
                                        priority
                                    />
                                </Link>
                            ))}
                        </CardContent>
                    </Card>
                </div>
                <WidgetPromo data={brandsModels} />
                <WidgetNav brands={brandsModels} />
                <WidgetLaunches data={brandsModels} />
            </main>
        </div>
    );
};

FicheTechniqueMain.propTypes = {
    brands: PropTypes.array.isRequired,
    brandsModels: PropTypes.array.isRequired,
};

export default FicheTechniqueMain;

export async function getStaticProps() {
    const brands = await getBrands();
    let brandsModels = await getBrandsModels();
    brandsModels = brandsModels.data.brands;
    return {
        props: {
            brands: brands.data.brands,
            brandsModels,
        },
    };
}
